import { useEffect, useState } from 'react'
import QRCode from 'qrcode'
import { DsAlert, DsButton, DsIcons, DsListGroup, DsListItem, DsMoney, DsSpinner, DsText, DsToast, useIsPhone } from '@/ds'
import { payRentStrings as s } from '@/features/payments/pay-rent-strings'
import type { UpiDirectResponse } from '@/types/models'

export function UpiDirectSheet({ order, onPaid, onCancel, busy }: { order: UpiDirectResponse; onPaid: () => void; onCancel: () => void; busy?: boolean }) {
  const phone = useIsPhone()
  const [qr, setQr] = useState<string | null>(null)
  useEffect(() => {
    let alive = true
    QRCode.toDataURL(order.intentUrl, { width: 240, margin: 1 }).then((u) => alive && setQr(u)).catch(() => alive && setQr(null))
    return () => {
      alive = false
    }
  }, [order.intentUrl])
  const copy = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text)
      DsToast.success(s.upiCopied)
    } catch {
      /* clipboard blocked: the value is on screen */
    }
  }
  // From md the QR sits beside the details; phones stack them with an Open UPI app button.
  return (
    <div className="flex flex-col gap-4 md:grid md:grid-cols-[auto_minmax(0,1fr)] md:items-start md:gap-6">
      <div className="flex flex-col items-center gap-2 md:row-span-3">
        {qr ? <img src={qr} alt={s.upiScan} width={240} height={240} className="rounded-xl border bg-white p-2" /> : <DsSpinner size={32} />}
        <DsText variant="small" muted>{s.upiScan}</DsText>
        {phone && <DsButton label={s.upiOpenApp} leadingIcon={DsIcons.mobile} onClick={() => { window.location.href = order.intentUrl }} fullWidth />}
      </div>
      <DsListGroup>
        <DsListItem title={s.upiPayee} subtitle={order.payeeName} />
        <DsListItem title={s.upiVpa} subtitle={order.vpa} trailing={<DsButton variant="ghost" size="sm" label={s.upiCopy} leadingIcon={DsIcons.copy} onClick={() => void copy(order.vpa)} />} />
        <DsListItem title={s.upiAmount} trailing={<DsMoney amount={order.amount} size="sm" />} />
      </DsListGroup>
      <DsAlert tone="info" title={s.upiConfirmTitle} description={s.upiConfirmMessage} />
      <div className="flex gap-2">
        <DsButton variant="outline" label={s.upiCancelButton} onClick={onCancel} disabled={busy} className="flex-1" />
        <DsButton label={s.upiConfirmButton} onClick={onPaid} loading={busy} className="flex-1" />
      </div>
    </div>
  )
}
